/**
 * Allows iterating over an array in reverse order with for...of without creating a new array or reversing the original array in place.
 *
 * @example
 * ```ts
 * const array = [1, 2, 3, 4, 5];
 * for (const value of reverseIterator(array)) {
 *   console.log(value); // 5, 4, 3, 2, 1
 * }
 */
export function* reverseIterator<TValue>(array: Array<TValue>): IterableIterator<TValue> {
  for (let i = array.length - 1; i >= 0; i -= 1) {
    yield array[i];
  }
}
